import React, { useState, useEffect } from "react";
import "./CSS/Aboutpage.css";
import Header from "./Components/Header";
import Footer from "./Components/Footer";
import Founder from "./Components/Founder";
import Achievements from "./Components/Achievement";
import Loader from "./Components/Loader";

const Aboutpage=()=>{

     useEffect(()=>{
                document.title="About | Balaji Badminton Academy"
              },[]);

    return(
        <div className="body">
        <Header/>
        <Loader/>
        <div className="about-page">
            <div className="row">
                <div class="Aboutpg_card">
                    <h1 className="text-white">About Us</h1>
                    <p>At Balaji badminton academy, we are dedicated to fostering the growth of badminton enthusiasts of all ages and skill levels. Whether you're a beginner eager to learn the basics or a seasoned player looking to refine your skills, our academy provides the perfect environment for players to improve their game. With certified coaches, state-of-the-art facilities, and a passion for the sport, we are committed to helping you reach your full potential on the court.</p>
                </div>
            <div className="about_anim">
                <div className="aboutside left"></div>
                <div className="aboutside right"></div>
                <div className="aboutwrapper">
                    <div className="frontabout image"></div>
                    <div className="backabout image1"></div>
                </div>
            </div>
            </div>
        </div>
        <Founder/>
        <Achievements/>
        <Footer/>
      </div>
    );
}

export default Aboutpage;